import { formFieldsEnum } from "../enums/formFieldsEnum";
import { IField } from "../interfaces/IField";

export const REPORT_FORM_FIELDS: IField[] = [
  { 
    name: "inn_client", 
    label: "ИНН Клиента",
    type: formFieldsEnum.TEXT,
  },
  {
    name: "name_client",
    label: "Наименование Клиента",
    type: formFieldsEnum.TEXT,
  },
  { name: "inn_agent", 
    label: "ИНН Агента", 
    type: formFieldsEnum.TEXT 
  },
  {
    name: "name_agent",
    label: "Наименование агента",
    type: formFieldsEnum.TEXT,
  },
  {
    name: "name_bank",
    label: "Наименование банка",
    placeholder: "Выбрать банк",
    type: formFieldsEnum.SELECT,
  },
  { 
    name: "bg_type", 
    label: "Тип БГ", 
    type: formFieldsEnum.SELECT, 
  },
  { 
    name: "fz", 
    label: "ФЗ", 
    type: formFieldsEnum.TEXT, 
  },
  { 
    name: "manager", 
    label: "Менеджер", 
    type: formFieldsEnum.SELECT, 
  },
  { 
    name: "start_date", 
    label: "Дата начала", 
    type: formFieldsEnum.DATE, 
  },
  { 
    name: "end_date", 
    label: "Дата окончания", 
    type: formFieldsEnum.DATE, 
  },
];